import { Document } from '@contentful/rich-text-types';
import { ComponentParameterEnhancerFunction } from '@uniformdev/canvas';

import { richTextToHTML, stripContentfulMetadata, getShouldStripExcessData } from './utils';

export const tableDataEnhancer: ComponentParameterEnhancerFunction<FeatureGroup[]> = async ({
	parameter,
}) => {
	const shouldStripExcessData = getShouldStripExcessData();

	if (shouldStripExcessData) {
		stripContentfulMetadata(parameter.value);
	}

	parameter.value?.forEach((featureGroup) => {
		featureGroup.fields.features.forEach((feature) => {
			if (
				typeof feature.fields.description === 'object' &&
				feature.fields.description?.nodeType === 'document'
			) {
				feature.fields.description = richTextToHTML(feature.fields.description);
			}
			if (shouldStripExcessData) {
				trimRelevantPlans(feature);
			}
		});
	});

	return parameter.value;
};

type RelevantPlan = {
	fields?: {
		planTitleExternal?: string;
		[key: string]: unknown;
	};
};

type FeatureAdditionalInformation = {
	fields?: {
		relevantPlan?: RelevantPlan[];
		[key: string]: unknown;
	};
};

export type FeatureGroup = {
	fields: {
		features: Array<{
			fields: {
				description: Document | string;
				relevantPlan?: RelevantPlan[];
				featureAdditionalInformation?: FeatureAdditionalInformation[];
			};
		}>;
	};
};

function trimRelevantPlans(feature: FeatureGroup['fields']['features'][number]) {
	feature.fields.relevantPlan?.forEach((plan) => {
		if (plan.fields) {
			plan.fields = { planTitleExternal: plan.fields.planTitleExternal };
		}
	});

	feature.fields.featureAdditionalInformation?.forEach((info) => {
		info.fields?.relevantPlan?.forEach((plan) => {
			if (plan.fields) {
				plan.fields = {
					planTitleExternal: plan.fields.planTitleExternal,
				};
			}
		});
	});
}
